import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { toLocalDate } from '@/utils/dateHelpers';
import { ArrowDownCircle, ArrowUpCircle, Tag } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { SystemPayment } from '@/hooks/useSystemPayments';

interface SystemTransactionCardProps {
  payment: SystemPayment;
}

const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

export const SystemTransactionCard = ({ payment }: SystemTransactionCardProps) => {
  const isReceivable = payment.type === 'receivable';

  return (
    <div className="p-4 hover:bg-muted/50 transition-colors">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className={`p-2 rounded-full ${isReceivable ? 'bg-green-100' : 'bg-red-100'}`}>
            {isReceivable ? (
              <ArrowDownCircle className="h-4 w-4 text-green-600" />
            ) : (
              <ArrowUpCircle className="h-4 w-4 text-red-600" />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <span className={`font-bold whitespace-nowrap tabular-nums ${isReceivable ? 'text-green-600' : 'text-red-600'}`}>
                {isReceivable ? '+' : '-'} {formatCurrency(payment.payment_value)}
              </span>
            </div>
            <p className="font-medium text-sm line-clamp-2 break-words" title={payment.description}>{payment.description}</p>
            {(payment.customer_name || payment.supplier_name) && (
              <p className="text-sm text-muted-foreground truncate" title={payment.customer_name || payment.supplier_name}>
                {isReceivable ? 'Cliente' : 'Fornecedor'}: {payment.customer_name || payment.supplier_name}
              </p>
            )}
          </div>
        </div>

        <div className="flex flex-col items-end gap-1 flex-shrink-0">
          <span className="text-sm text-muted-foreground">
            {format(toLocalDate(payment.payment_date), 'dd/MM/yyyy', { locale: ptBR })}
          </span>
          <Badge variant="outline" className="text-xs">
            {isReceivable ? 'Recebimento' : 'Pagamento'}
          </Badge>
        </div>
      </div>
    </div>
  );
};
